export default [
	{
		LanguageId: 1,
		Code: "en-us",
		Name: "English (United States)",
		Icon: "🇺🇸",
	},
	{
		LanguageId: 2,
		Code: "de-ch",
		Name: "Deutsch (Schweiz)",
		Icon: "🇨🇭",
	},
	{
		LanguageId: 3,
		Code: "fr-fr",
		Name: "Français (France)",
		Icon: "🇫🇷",
	},
];
